import * as types from './types'

export const mutations = {
  [types.SET_CLIENTS] (state, clients) {
		state.clients = [...clients]
  },
  [types.SET_CLIENT] (state, client) {
    const advisor = {
      first_name: '',
      last_name: ''
    }
    state.client = {main_advisor: advisor, ...client}
    if (!client.user.office) {
      state.client.user.office = {
        name: ''
      }
    }
    state.client.picture = (client.user.media) ? process.env.ASSETS_ROOT + client.user.media.file : process.env.API_ROOT + '/assets/user.png'
	},
	[types.CREATE_CLIENT] (state, { client }) {
		state.clients.push(client)
	},
	[types.EDIT_CLIENT] (state, { client }) {
    state.clients.forEach((el, index) => {
      if (client.id === el.id) {
				console.log(state.clients[index])
        state.clients[index].user = client
				state.client.user = client
      }
    });
		state.clients = state.clients
	},
	[types.ENABLE_CLIENT] (state, id) {
    let target = state.clients.find((client) => {
      return client.id === id;
    })
    target.enabled = true;
	},
	[types.DISABLE_CLIENT] (state, id) {
    let target = state.clients.find((client) => {
      return client.id === id;
    })
    target.enabled = false;
  },
  [types.SET_ESTATE] (state, estate) {
		state.estate = estate
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Clients/mutations.js